/**
 * A live "waiting for" timer — ticks so the reviewer can triage by how long a report has
 * sat unreviewed without refreshing the page.
 */
import { formatDuration, useNowTick } from '../../lib/waiting';

export function WaitingTimer({ since }: { since: string | null }) {
  const now = useNowTick(1000);
  if (!since) return <span className="muted">—</span>;
  const ms = now - new Date(since).getTime();
  return <span className="waiting-timer">{formatDuration(ms)}</span>;
}
